<template>
  <div class="flex">
    <ui-link
      v-if="collection.slug"
      v-tooltip="'Open on OpenSea'"
      target="_blank"
      class="
        inline-flex
        items-center
        p-2
        opacity-75
        hover:opacity-100
        cursor-pointer
      "
      :href="`https://opensea.io/collection/${collection.slug}`"
    >
      <img
        src="../../assets/opensea-dark.svg"
        class="hidden dark:block h-4"
      >
      <img
        src="../../assets/opensea-light.svg"
        class="block dark:hidden h-4"
      >
    </ui-link>
    <ui-link
      v-if="collection.id"
      v-tooltip="'Open on LooksRare'"
      target="_blank"
      class="
        inline-flex
        items-center
        p-2
        opacity-75
        hover:opacity-100
        cursor-pointer
      "
      :href="`https://looksrare.org/collections/${collection.id}`"
    >
      <img
        src="../../assets/looksrare-dark.svg"
        class="hidden dark:block h-4"
      >
      <img
        src="../../assets/looksrare-light.svg"
        class="block dark:hidden h-4"
      >
    </ui-link>
    <ui-link
      v-if="collection.id"
      v-tooltip="'Open on Genie'"
      target="_blank"
      class="
        inline-flex
        items-center
        p-2
        text-white
        opacity-75
        hover:opacity-100
        cursor-pointer
      "
      :href="`https://www.genie.xyz/collection/${collection.id}`"
    >
      <genie-icon class="w-4 h-4" />
    </ui-link>
    <ui-link
      v-if="collection.slug"
      v-tooltip="'View contract on Etherscan'"
      target="_blank"
      class="
        inline-flex
        items-center
        p-2
        opacity-75
        hover:opacity-100
        cursor-pointer
      "
      :href="`https://etherscan.io/token/${collection.id}`"
    >
      <img
        src="../../assets/etherscan-dark.svg"
        class="hidden dark:block h-4"
      >
      <img
        src="../../assets/etherscan-light.svg"
        class="block dark:hidden h-4"
      >
    </ui-link>
    <ui-link
      v-if="collection.externalUrl"
      v-tooltip="'View Website'"
      target="_blank"
      class="
        inline-block
        p-2
        text-gray-600
        hover:text-indigo-600
        cursor-pointer
        dark:text-gray-400 dark:hover:text-indigo-400 transition-colors
      "
      :href="collection.externalUrl"
    >
      <i class="far fa-browser" />
    </ui-link>
    <ui-link
      v-if="collection.discordUrl"
      v-tooltip="'Join Discord'"
      target="_blank"
      class="
        inline-block
        p-2
        text-gray-600
        hover:text-indigo-600
        cursor-pointer
        dark:text-gray-400 dark:hover:text-indigo-400 transition-colors
      "
      :href="collection.discordUrl"
    >
      <i class="fab fa-discord" />
    </ui-link>
    <ui-link
      v-if="collection.twitterUsername"
      v-tooltip="'Follow on Twitter'"
      target="_blank"
      class="
        inline-block
        p-2
        text-gray-600
        hover:text-indigo-600
        cursor-pointer
        dark:text-gray-400 dark:hover:text-indigo-400 transition-colors
      "
      :href="`https://twitter.com/${collection.twitterUsername}`"
    >
      <i class="fab fa-twitter" />
    </ui-link>
    <ui-link
      v-if="collection.telegramUrl"
      v-tooltip="'Telegram'"
      target="_blank"
      class="
        inline-block
        p-2
        text-gray-600
        hover:text-indigo-600
        cursor-pointer
        dark:text-gray-400 dark:hover:text-indigo-400 transition-colors
      "
      :href="collection.telegramUrl"
    >
      <i class="fab fa-telegram" />
    </ui-link>
    <ui-link
      v-if="collection.mediumUsername"
      v-tooltip="'Medium'"
      target="_blank"
      class="
        inline-block
        p-2
        text-gray-600
        hover:text-indigo-600
        cursor-pointer
        dark:text-gray-400 dark:hover:text-indigo-400 transition-colors
      "
      :href="`https://medium.com/@${collection.mediumUsername}`"
    >
      <i class="fab fa-medium" />
    </ui-link>
    <ui-link
      v-if="collection.instagramUsername"
      v-tooltip="'Instagram'"
      target="_blank"
      class="
        inline-block
        p-2
        text-gray-600
        hover:text-indigo-600
        cursor-pointer
        dark:text-gray-400 dark:hover:text-indigo-400 transition-colors
      "
      :href="`https://www.instagram.com/${collection.instagramUsername}/`"
    >
      <i class="fab fa-instagram" />
    </ui-link>
  </div>
</template>

<script>
import UiLink from '../ui/UiLink.vue';
import GenieIcon from '../GenieIcon.vue'
export default {
  components: { UiLink, GenieIcon },
  props: ['collection']
};
</script>

<style>
</style>